import { Component, inject } from '@angular/core';
import { MainLayoutComponent } from './core/components/main-layout/main-layout.component';
import { ConsoleService } from './core/services/console.service';

@Component({
  selector: 'app-root',
  imports: [MainLayoutComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'event-hub';

  // biome-ignore lint/complexity/noUselessConstructor: we must inject the console service
  constructor(_: ConsoleService = inject(ConsoleService)) {}
}
